import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  AttachmentsScope,
  ImageDisplayStyle,
  ReportFieldsContent,
} from './common';

const ISSUE_FIELD_NAMES = new Set<string>(Object.values(IssueFieldNames));

export function isReportFieldsContent(value: string): value is ReportFieldsContent {
  return (
    value === ReportFieldsContent.all
    || value === ReportFieldsContent.filled
    || value === ReportFieldsContent.selected
  );
}

export function isImageDisplayStyle(value: string): value is ImageDisplayStyle {
  return (
    value === ImageDisplayStyle.miniatures
    || value === ImageDisplayStyle.fullPage
    || value === ImageDisplayStyle.list
  );
}

export function isAttachmentsScope(value: string): value is AttachmentsScope {
  return value === AttachmentsScope.all || value === AttachmentsScope.main;
}

export function isIssueFieldName(value: string): value is IssueFieldNames {
  return ISSUE_FIELD_NAMES.has(value);
}

export function isImageDisplayStyleList(
  displayStyle: ImageDisplayStyle,
): displayStyle is ImageDisplayStyle.list {
  return displayStyle === ImageDisplayStyle.list;
}

export function isImageDisplayStyleFullPage(
  displayStyle: ImageDisplayStyle,
): displayStyle is ImageDisplayStyle.fullPage {
  return displayStyle === ImageDisplayStyle.fullPage;
}

export function isImageDisplayStyleMiniatures(
  displayStyle: ImageDisplayStyle,
): displayStyle is ImageDisplayStyle.miniatures {
  return displayStyle === ImageDisplayStyle.miniatures;
}

export function isAttachmentsScopeMain(
  scope: AttachmentsScope,
): scope is AttachmentsScope.main {
  return scope === AttachmentsScope.main;
}
